import { SplitFactory } from "@splitsoftware/splitio";
import path from "path";
import { GENERIC_CLIENT_ERROR } from "./constants";
import isClientSide from "./isClientSide";
let factory;
let client;
const initiateSplitClient = async () => {
    if (isClientSide()) {
        throw new Error("Do not initiate Split client-side. This function is not designed to handle client-side initiation.");
    }
    const authorizationKey = process.env.SPLIT_SERVER_KEY || "localhost";
    const debug = process.env.SPLIT_DEBUG;
    const localhostMode = authorizationKey === "localhost";
    const features = localhostMode
        ? path.join(process.cwd(), "split-config.yml")
        : undefined;
    factory ||= SplitFactory({
        core: {
            authorizationKey,
        },
        debug: debug === "true",
        features,
    });
    client ||= factory.client();
    try {
        // Timeout errors need to be explicitly propagated when using async/await, per Split docs:
        // https://github.com/splitio/javascript-client/blob/71fc362b9b97a58339529de253e417ea0f861f66/types/splitio.d.ts#L444
        await client.ready().catch((e) => {
            throw e;
        });
        return client;
    }
    catch (e) {
        throw new Error((typeof e === "object" && e.message) || GENERIC_CLIENT_ERROR);
    }
};
process.on("exit", async () => {
    await client?.destroy();
});
export default initiateSplitClient;
